import { KeyLocationsList } from "./KeyLocationsList";

export default {
  title: "SecurityPortal/Events/KeyLocationsList",
  component: KeyLocationsList,
  decorators: [
    (Story) => (
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          fontFamily: "Helvetica Neue",
          height: "260px",
          width: "554px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <KeyLocationsList {...args} />;

export const Default = Template.bind({});
Default.args = {
  onUpload: () => alert("onUpload fired."),
  locationItems: [
    {
      name: "Hospital",
      addressLine1: "1810 N Greene St",
      addressLine2: "",
      phone: "(000) 000-0000",
    },
    {
      name: "Police Station",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      phone: "(000) 000-0000",
    },
    {
      name: "FBI Office",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      phone: "(000) 000-0000",
    },
  ],
};
